<template>
    <v-icon class="grey--text" v-if="statusCode === -1">fal fa-ban</v-icon><!--CPDS_CANCELED = -1-->
    <v-icon class="amber--text" v-else-if="statusCode === 2">fal fa-coins</v-icon><!--CPDS_PENDING_PAYMENT = 2-->
    <v-icon class="amber--text" v-else-if="statusCode === 3">fal fa-shield-check</v-icon><!--CPDS_PAID = 3-->
    <v-icon class="amber--text" v-else-if="statusCode === 4">fal fa-envelope</v-icon><!--CPDS_CONFIRMED = 4-->
    <v-icon class="blue--text" v-else-if="statusCode === 5">fal fa-box-full</v-icon><!--CPDS_PROCESSING = 5-->
    <v-icon class="blue--text" v-else-if="statusCode === 6">fal fa-box-check</v-icon><!--CPDS_PROCESSED = 6-->
    <v-icon class="amber--text" v-else-if="statusCode === 7">fal fa-hand-holding-box</v-icon><!--CPDS_PENDING = 7-->
    <v-icon class="green--text" v-else-if="statusCode === 8">fal fa-flag-checkered</v-icon><!--CPDS_DELIVERED = 8-->
    <v-icon class="error--text" v-else-if="statusCode === 9">fal fa-undo</v-icon><!--CPDS_RETURNED = 9-->
    <v-icon class="amber--text" v-else>fal fa-envelope</v-icon>
</template>

<script>
    export default {
        name: "OrdersStatus",
        props: {
            statusCode: Number
        },
    }
</script>

<style scoped>

</style>